var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLmsProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 373,
    viewBox: "0 0 500 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_733_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 327.4H0V327.6H500V327.4Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.3 338.9H394.4V339.1H445.3V338.9Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7 335.9H52.5V336.1H99.7V335.9Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 334.3H378.8V334.5H398V334.3Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.2 340.9H317.1V341.1H331.2V340.9Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2 340.9H272.8V341.1H308.2V340.9Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.2 336.7H195.2V336.9H252.2V336.7Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 282.8H43.9002C40.8002 282.8 38.2002 280.2 38.2002 277.1V5.7C38.2002 2.6 40.8002 0 43.9002 0H237C240.1 0 242.7 2.6 242.7 5.7V277.1C242.7 280.3 240.2 282.8 237 282.8ZM43.9002 0.2C40.9002 0.2 38.4002 2.6 38.4002 5.7V277.1C38.4002 280.1 40.8002 282.6 43.9002 282.6H237C240 282.6 242.5 280.2 242.5 277.1V5.7C242.5 2.7 240.1 0.2 237 0.2H43.9002Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3 282.8H260.2C257.1 282.8 254.5 280.2 254.5 277.1V5.7C254.5 2.6 257.1 0 260.2 0H453.3C456.4 0 459 2.6 459 5.7V277.1C459 280.3 456.5 282.8 453.3 282.8ZM260.2 0.2C257.2 0.2 254.7 2.6 254.7 5.7V277.1C254.7 280.1 257.1 282.6 260.2 282.6H453.3C456.3 282.6 458.8 280.2 458.8 277.1V5.7C458.8 2.7 456.4 0.2 453.3 0.2H260.2Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.401 30.6992H288.601V327.399H390.401V30.6992Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.452 321.408L383.452 36.708L295.352 36.708L295.352 321.408H383.452Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5 30.6992H183.7V327.399H285.5V30.6992Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.491 326.259H288.591L288.591 31.8588H285.491L285.491 326.259Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.599 321.461L278.599 36.7607L190.499 36.7607L190.499 321.461H278.599Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.9 28.4994H137.2C136.5 28.4994 135.9 27.8994 135.9 27.1994C135.9 26.4994 136.5 25.8994 137.2 25.8994H436.9C437.6 25.8994 438.2 26.4994 438.2 27.1994C438.2 27.8994 437.6 28.4994 436.9 28.4994Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.52 42.3758V36.6758L295.42 36.6758V42.3758L383.52 42.3758Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.464 46.3197V36.7197L295.364 36.7197V46.3197L383.464 46.3197Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.678 57.6393V36.7393L190.578 36.7393V57.6393L278.678 57.6393Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.4 19.5996H375.2V323.8H403.4V19.5996Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 19.5996H382.7V323.8H396V19.5996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6 19.5996H390.4V323.8H418.6V19.5996Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.1 19.5996H397.8V323.8H411.1V19.5996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7 19.5996H404.5V323.8H432.7V19.5996Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.4 19.5996H140.5V323.8H181.4V19.5996Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6 19.5996H151.3V323.8H170.6V19.5996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.4 19.5996H162.5V323.8H203.4V19.5996Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6 19.5996H173.3V323.8H192.6V19.5996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8 19.5996H182.9V323.8H223.8V19.5996Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 50.7998H55.0996V199.5H121.1V50.7998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.084 199.431H123.184L123.184 50.7307H121.084L121.084 199.431Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.102 193.528L115.102 56.8281L61.1016 56.8281L61.1016 193.528H115.102Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 273.099H57.5004C54.4004 273.099 51.9004 270.599 51.9004 267.499C51.9004 264.399 54.4004 261.899 57.5004 261.899H125.3C128.4 261.899 130.9 264.399 130.9 267.499C130.9 270.599 128.4 273.099 125.3 273.099Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 273.1H62.7L50 327.4H61.1L73.8 273.1Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9996 273.1H84.8996L78.5996 327.4H89.7996L95.9996 273.1Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 273.1H120.1L132.7 327.4H121.6L109 273.1Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 372.6C357.088 372.6 443.9 367.541 443.9 361.3C443.9 355.059 357.088 350 250 350C142.912 350 56.0996 355.059 56.0996 361.3C56.0996 367.541 142.912 372.6 250 372.6Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.599 252.599H229.299C227.699 252.599 226.399 251.299 226.399 249.699V246.299C226.399 244.699 227.699 243.399 229.299 243.399H314.599C316.199 243.399 317.499 244.699 317.499 246.299V249.699C317.499 251.299 316.199 252.599 314.599 252.599Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8 355.3H317.5L313.2 252.6H308L313.8 355.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M313.8 355.3H317.5L313.2 252.6H308L313.8 355.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3 355.3H275.6L279.9 252.6H285.1L279.3 355.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M279.3 355.3H275.6L279.9 252.6H285.1L279.3 355.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 355.3H268.2L263.9 252.6H258.7L264.5 355.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M264.5 355.3H268.2L263.9 252.6H258.7L264.5 355.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1 355.3H226.3L230.6 252.6H235.8L230.1 355.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M230.1 355.3H226.3L230.6 252.6H235.8L230.1 355.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.199 252.6H307.999L308.299 257H313.399L313.199 252.6Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.699 257H284.799L285.099 252.6H279.899L279.699 257Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.699 252.6L258.999 257H264.099L263.899 252.6H258.699Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.399 257H235.599L235.799 252.6H230.599L230.399 257Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.1 340.199L253.6 344.699L240.3 326.699L248.8 322.199L262.1 340.199Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 341.9L259.4 335.8C259.7 335.6 260.1 335.6 260.4 335.9L265.7 342.6C266.2 343.3 266 344.5 265.3 345C262.2 347.1 260.8 347.8 256.7 350.2C254.2 351.7 248.2 355.2 244.5 356.8C240.9 358.4 239.3 354.7 240.8 353.7C244.2 351.3 248.6 346.6 249.6 343.3C249.7 342.8 250.1 342.2 250.6 341.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.8 322.199L240.3 326.699L246.7 335.399L255 330.599L248.8 322.199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2 215.499C269.2 215.499 203.5 213.499 203.2 240.899C202.9 280.399 240.3 332.199 240.3 332.199L254.9 322.499C254.9 322.499 229.2 284.799 229 253.999C248.4 248.499 294 251.999 299.9 235.899C304.7 222.799 302.2 215.499 302.2 215.499H269.2Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M269.2 215.499C269.2 215.499 203.5 213.499 203.2 240.899C202.9 280.399 240.3 332.199 240.3 332.199L254.9 322.499C254.9 322.499 229.2 284.799 229 253.999C248.4 248.499 294 251.999 299.9 235.899C304.7 222.799 302.2 215.499 302.2 215.499H269.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 325L241.5 335.7L236.1 330.2L255.2 318.1L259 325Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7 345.199C249.4 344.699 250.1 343.999 250.6 343.499C250.7 343.399 250.7 343.299 250.6 343.299C250.6 343.199 250.5 343.199 250.4 343.199C250 343.199 246.7 343.199 246 344.299C245.8 344.499 245.8 344.799 245.9 345.099C246.1 345.599 246.4 345.899 246.8 345.899C247.5 345.899 248.1 345.699 248.7 345.199ZM249.9 343.599C248.7 344.899 247.6 345.499 247 345.399C246.7 345.399 246.6 345.199 246.4 344.799C246.3 344.599 246.3 344.499 246.4 344.399C246.9 343.899 248.6 343.599 249.9 343.599Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 343.499C250.7 343.399 250.7 343.299 250.7 343.199C250.6 343.099 249.2 340.699 247.9 340.499C247.5 340.399 247.2 340.499 246.9 340.799C246.6 341.099 246.5 341.499 246.6 341.799C247 342.799 249.3 343.599 250.4 343.499C250.5 343.599 250.6 343.499 250.6 343.499ZM247.3 341.099C247.5 340.999 247.6 340.999 247.8 340.999C248.6 341.099 249.6 342.399 250.1 343.099C249 342.999 247.4 342.299 247.1 341.599C247 341.499 247 341.399 247.3 341.099Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.399 351.2L236.899 350.8L235.399 328.4L244.899 328.8L246.399 351.2Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7 349.2L247.5 348.9C247.9 348.9 248.2 349.2 248.2 349.5L249 358C249.1 358.9 248.3 359.7 247.4 359.8C243.7 359.9 241.9 359.7 237.1 359.8C234.2 359.9 228.5 360.3 224.5 359.8C220.6 359.3 221.1 355.4 222.9 355.2C227 354.9 232.5 352 235.2 349.8C235.6 349.4 236.1 349.2 236.7 349.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4 350.9C234.3 350.9 235.3 350.7 235.9 350.5C236 350.5 236 350.4 236.1 350.3C236.1 350.2 236.1 350.1 236 350.1C235.7 349.9 232.9 348.1 231.8 348.6C231.5 348.7 231.4 348.9 231.3 349.2C231.2 349.7 231.3 350.1 231.6 350.4C231.9 350.9 232.6 351 233.4 350.9ZM235.3 350.2C233.6 350.6 232.3 350.6 231.9 350.2C231.7 350 231.6 349.8 231.7 349.4C231.7 349.2 231.8 349.1 231.9 349.1C232.5 348.8 234.2 349.5 235.3 350.2Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.9 350.5H236C236.1 350.5 236.1 350.4 236.1 350.3C236.1 350.2 236.2 347.4 235.2 346.5C234.9 346.3 234.6 346.2 234.2 346.2C233.8 346.3 233.5 346.5 233.4 346.9C233.2 348 234.7 349.9 235.7 350.4C235.8 350.5 235.8 350.5 235.9 350.5ZM234.4 346.7C234.6 346.7 234.7 346.8 234.9 346.9C235.5 347.4 235.6 349 235.6 349.9C234.7 349.2 233.7 347.7 233.9 347C233.9 346.9 234 346.7 234.3 346.7C234.4 346.7 234.4 346.7 234.4 346.7Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.899 328.8L235.399 328.4L236.299 341.2H245.699L244.899 328.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6 215.5C292.6 215.5 223.8 222 226.3 242.7C229.9 272.6 231.7 336.9 231.7 336.9L249.2 337.6C249.2 337.6 256.6 279.5 252.8 249C270.6 249 314.2 250.3 318.2 239.6C321.7 230.1 320.5 215.6 320.5 215.6H292.6V215.5Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.199 338.7L230.099 337.7L229.399 328.5L252.399 330.1L251.199 338.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3 154.9C277.2 156.6 277 158 276.8 159.6C276.6 161.1 276.4 162.6 276.2 164.2C275.7 167.2 275.1 170.2 274.4 173.3C272.9 179.3 271.2 185.4 267.8 191.5C266.9 193 266 194.6 264.7 196.1C263.5 197.6 261.9 199.2 260.2 200.3C256.7 202.7 252.8 203.8 249.1 204C245.4 204.3 242 203.8 238.8 203C237.2 202.6 235.6 202.1 234.1 201.5C233.3 201.2 232.6 200.9 231.9 200.5C231.1 200.2 230.5 199.8 229.7 199.3L232.3 192.6L234.2 192.8L236.2 193C237.5 193.1 238.9 193.2 240.2 193.2C242.8 193.2 245.3 193 247.4 192.4C249.5 191.8 251.3 190.9 252.5 189.8C253.1 189.2 253.6 188.7 254.2 187.9C254.8 187.1 255.3 186.1 255.8 185.1C256.8 183 257.7 180.5 258.4 178C259.2 175.5 259.8 172.8 260.3 170.1C260.9 167.4 261.3 164.7 261.8 161.9L262.4 157.8C262.6 156.4 262.8 155 262.9 153.8L277.3 154.9Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4 146.7C270.4 139.9 261.7 143.9 258.2 156.6C254.7 169.3 254.2 177.5 254.2 177.5L276.5 182.1C280.5 170 284.6 153.7 277.4 146.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.2 160.6C271.8 159.2 276.3 165.6 279.1 173.5C278.3 176.5 277.4 179.4 276.5 182.1L263.1 179.3C264.2 171.5 266.6 163.8 270.2 160.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.9 189.6L225.9 187.7L225.7 198.3C225.7 198.3 234.1 201.9 235.8 197.8L235.2 195.2C234.7 192.8 233.1 190.8 230.9 189.6Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 188L217 196.9L225.7 198.3L225.9 187.7L220 188Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 194.999C227.3 194.999 227.1 194.899 227 194.699L218.1 177.499C218 177.199 218.1 176.899 218.3 176.699C218.6 176.599 218.9 176.699 219.1 176.899L228 194.099C228.1 194.399 228 194.699 227.8 194.899C227.7 194.999 227.6 194.999 227.5 194.999Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5 139.899L287.2 136.899L300.9 136.299C305.2 136.099 309.1 138.799 310.4 142.899C313 150.899 315.4 162.399 317.2 172.399C319.2 183.599 320.2 200.399 320.4 215.699H269.2C268 183.899 264 164.999 262.2 154.599C261.5 150.399 263.6 146.199 267.5 144.399L276.5 139.899Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M317.2 172.3C315.8 164.5 314 155.6 312.1 148.3C303 146.8 298.5 166.8 301.3 176.7C304 186.6 318.5 180.6 318.5 180.6C318 177.6 317.6 174.8 317.2 172.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 116.1C287.6 121.5 286.3 131.4 281.9 128.6C277.6 125.8 284.1 112.8 285.4 116.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 119.5L278.9 125.8L273.3 134.4C273.7 134.6 274.5 136 275 137C276 139.1 276.9 140.6 272.5 143.6C271.6 144.2 271 145.4 271.2 146.5C271.5 147.8 272.8 149.2 277.5 148.3C283 147.3 286.6 144.5 289.3 141.7C290.9 140.1 290.5 138.9 289 137.3C284.7 132.8 283.4 125.4 283 119.5Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274.6 132.399L278.1 126.199C278.2 126.399 278.3 126.499 278.3 126.699C278.6 127.399 278.8 128.199 279 129.099C279.6 131.799 277.5 135.699 275.2 137.599C275.1 137.399 275 137.199 274.9 137.099C274.5 136.199 273.7 134.999 273.3 134.599L273.2 134.499L274.6 132.399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 111.999C252.5 114.899 257.1 123.199 262.3 119.799C267.5 116.499 256.1 106.899 253.8 111.999Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 150.1C278.9 150.1 278.7 150 278.7 149.9C278.3 147.4 276.7 145.9 274.9 144C272.6 141.7 270 139.1 269.1 134.1C269.1 133.9 269.2 133.8 269.3 133.8C269.5 133.8 269.6 133.9 269.6 134C270.4 138.9 273 141.4 275.2 143.6C277 145.4 278.8 147.1 279.2 149.8C279.3 149.9 279.2 150.1 279 150.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.1 109.099C283.1 118.199 284.7 123.399 281.4 129.099C276.5 137.799 264.3 136.599 259.7 128.299C255.5 120.799 253 107.199 260.8 101.399C268.5 95.5991 279.2 100.099 281.1 109.099Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.8 115.3C280.7 119.7 272.5 111.6 273.2 106.1C265.1 110.7 256.3 116.9 250.9 111.7C244.7 105.7 246.4 97.0999 253.7 96.2999C252.4 98.7999 259.7 99.8999 263.6 95.9999C270.1 89.4999 280.5 90.8999 280.3 96.0999C285.2 94.2999 290.7 105.6 283.8 115.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3 97.6996C281.2 96.2996 279.9 91.0996 275.5 89.5996C279.7 90.1996 284.1 93.3996 279.3 97.6996Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.7 114.899C286.8 117.199 286 119.299 284.8 120.599C283.1 122.599 280.4 120.999 279.8 118.499C279.2 116.199 280 112.699 282.2 111.599C284.5 110.499 286.6 112.399 286.7 114.899Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.1 116.499C268.3 117.199 268.2 117.999 267.7 118.099C267.2 118.299 266.6 117.799 266.4 117.099C266.2 116.399 266.3 115.599 266.8 115.499C267.3 115.299 267.9 115.699 268.1 116.499Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9 119.499C260.1 120.199 260 120.999 259.5 121.099C259 121.299 258.4 120.799 258.2 120.099C258 119.399 258.1 118.599 258.6 118.499C259.1 118.299 259.7 118.699 259.9 119.499Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7 119.1C262.7 119.1 262.8 123.2 261.9 125.6C263.4 126.1 265 124.9 265 124.9L262.7 119.1Z",
    fill: "#ED893E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1 128.9C270 127.9 271 125.6 271 125.4C271 125.3 271 125.2 270.9 125.1C270.8 125.1 270.7 125.1 270.6 125.2C270.6 125.2 269.5 127.9 266.1 128.6C266 128.6 265.9 128.7 265.9 128.9C265.9 129 266 129.1 266.2 129.1C266.6 129.1 266.9 129 267.1 128.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9 113.3C269 113.3 269 113.2 269.1 113.1C269.2 112.9 269.2 112.6 269 112.5C266.9 111.2 265 112 264.9 112.1C264.7 112.2 264.6 112.5 264.7 112.7C264.8 112.9 265.1 113 265.3 112.9C265.4 112.9 266.9 112.2 268.5 113.3C268.6 113.4 268.7 113.4 268.9 113.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 114.7C258.3 114.6 258.3 114.5 258.3 114.5C258.2 114.3 257.9 114.2 257.7 114.3C255.4 115.3 255 117.3 255 117.4C254.9 117.6 255.1 117.9 255.4 117.9C255.6 117.9 255.9 117.8 255.9 117.5C255.9 117.4 256.2 115.8 258 115.1C258.2 115 258.3 114.9 258.3 114.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7 143.1C309.7 144.7 310.5 146.2 311.3 147.7C312.1 149.2 312.9 150.8 313.7 152.3C315.3 155.4 316.7 158.6 318.1 161.9C319.4 165.2 320.7 168.5 321.7 172C322.7 175.5 323.6 179.2 324 183.3C324.2 185.4 324.2 187.5 323.8 190C323.6 191.1 323.2 192.7 322.5 194.2C321.8 195.7 320.7 197.1 319.4 198.1C318.2 199.2 316.8 199.9 315.5 200.4C314.2 200.9 313 201.2 311.8 201.4C309.5 201.8 307.4 201.7 305.4 201.6C303.4 201.4 301.5 201.1 299.7 200.7C297.9 200.3 296.1 199.8 294.4 199.2C291 198.1 287.8 196.7 284.5 195L287 188.3C293.2 189.5 299.9 190.6 305.5 190.2C306.9 190.1 308.2 189.9 309.1 189.6C310.1 189.3 310.6 188.9 310.6 188.7C310.6 188.6 310.5 188.7 310.5 188.6C310.5 188.5 310.5 188.5 310.5 188C310.6 187.1 310.5 185.9 310.3 184.6C309.9 182 309.1 179.1 308.1 176.2C307.1 173.3 305.9 170.4 304.6 167.5C303.3 164.6 301.9 161.7 300.5 158.8C299.8 157.4 299 155.9 298.3 154.5L296 150.3L308.7 143.1Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.001 136.399C294.301 134.899 289.601 143.199 294.101 155.599C298.601 167.999 302.901 174.899 302.901 174.899L323.701 165.799C320.001 153.499 313.901 137.899 304.001 136.399Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.801 187.4L277.301 188.7L283.601 197.7C283.601 197.7 293.001 194.3 291.101 190.3L288.701 189C286.801 187.8 284.201 186.6 281.801 187.4Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.4 195L277.9 199.4L283.7 197.8L277.4 188.8L273.4 195Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2 117.799C283.973 117.799 284.6 117.038 284.6 116.099C284.6 115.161 283.973 114.399 283.2 114.399C282.427 114.399 281.8 115.161 281.8 116.099C281.8 117.038 282.427 117.799 283.2 117.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.4 120.7L283.5 120.6L283 116.6L284.6 116.3L284.4 120.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1 196.2C287.1 196.2 284.4 195.8 282.8 194.3C281.6 193.3 281.1 191.7 281.1 189.8C281.1 185 282.1 181.1 283 177.6C284.4 172.2 285.5 167.8 282.2 162.5C276.9 154.1 278.5 142.3 282.2 134.9C285.1 129.2 284.1 123 283.7 120.6C283.7 120.3 283.6 120.1 283.6 119.9C283.6 119.7 283.7 119.6 283.9 119.6C284.1 119.6 284.2 119.7 284.2 119.9C284.2 120.1 284.2 120.3 284.3 120.6C284.7 123 285.7 129.4 282.7 135.2C279 142.4 277.5 154 282.7 162.2C286.2 167.7 285 172.3 283.6 177.7C282.7 181.1 281.7 185 281.7 189.7C281.7 191.5 282.2 192.8 283.3 193.8C286 196.2 292 195.6 297.7 195C300.3 194.7 302.9 194.5 305.3 194.5C305.5 194.5 305.6 194.6 305.6 194.8C305.6 195 305.5 195.1 305.3 195.1C303 195.1 300.3 195.4 297.8 195.6C295.1 196 292.5 196.2 290.1 196.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.2 194.1H305.8C305.5 194.1 305.2 194.4 305.2 194.7V195.5C305.2 195.8 305.5 196.1 305.8 196.1H317.2C317.5 196.1 317.8 195.8 317.8 195.5V194.7C317.8 194.4 317.6 194.1 317.2 194.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6 202.8H111.4C109.6 202.8 108.1 201.3 108.1 199.5C108.1 197.7 109.6 196.2 111.4 196.2H388.7C390.5 196.2 392 197.7 392 199.5C392 201.3 390.5 202.8 388.6 202.8Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M388.599 202.8H323.699C321.899 202.8 320.399 201.3 320.399 199.5C320.399 197.7 321.899 196.2 323.699 196.2H388.599C390.399 196.2 391.899 197.7 391.899 199.5C391.999 201.3 390.499 202.8 388.599 202.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.6 359.7H392L384.6 202.8H375.8L385.6 359.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M385.6 359.7H392L384.6 202.8H375.8L385.6 359.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.8 359.7H320.4L327.8 202.8H336.6L326.8 359.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M326.8 359.7H320.4L327.8 202.8H336.6L326.8 359.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.2 359.7H179.6L172.2 202.8H163.4L173.2 359.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.2 359.7H179.6L172.2 202.8H163.4L173.2 359.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4 359.7H108L115.4 202.8H124.2L114.4 359.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.4 359.7H108L115.4 202.8H124.2L114.4 359.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.5 211.1H117.2V224.2H330.5V211.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M330.5 211.1H117.2V224.2H330.5V211.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3 187.3C151.5 187.3 150.9 187.9 150.9 188.7V194.8C150.9 195.6 151.5 196.2 152.3 196.2H197.7C198 196.2 198.2 196 198.2 195.7V187.8C198.2 187.5 198 187.3 197.7 187.3H152.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M198.101 188.1H179.101C178.701 188.1 178.301 188.5 178.301 188.9V194.4C178.301 194.8 178.701 195.2 179.101 195.2H198.101V188.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.001 187.3H130.201C129.401 187.3 128.801 187.9 128.801 188.7V194.8C128.801 195.6 129.401 196.2 130.201 196.2H176.001C176.801 196.2 177.401 195.6 177.401 194.8V188.7C177.401 187.9 176.801 187.3 176.001 187.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.001 187.3H130.201C129.401 187.3 128.801 187.9 128.801 188.7V194.8C128.801 195.6 129.401 196.2 130.201 196.2H176.001C176.801 196.2 177.401 195.6 177.401 194.8V188.7C177.401 187.9 176.801 187.3 176.001 187.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M153.501 187.3H146.601C146.301 187.3 146.001 187.6 146.001 187.9V195.6C146.001 195.9 146.301 196.2 146.601 196.2H153.501C153.801 196.2 154.101 195.9 154.101 195.6V187.9C154.101 187.5 153.801 187.3 153.501 187.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M163.601 187.3H156.701C156.401 187.3 156.101 187.6 156.101 187.9V195.6C156.101 195.9 156.401 196.2 156.701 196.2H163.601C163.901 196.2 164.201 195.9 164.201 195.6V187.9C164.101 187.5 163.901 187.3 163.601 187.3Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1 176.4C143.3 176.4 142.7 177 142.7 177.8V185.9C142.7 186.7 143.3 187.3 144.1 187.3H193.2C193.5 187.3 193.7 187.1 193.7 186.8V176.8C193.7 176.5 193.5 176.3 193.2 176.3H144.1V176.4Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M193.7 177.2H171C170.6 177.2 170.2 177.6 170.2 178V185.6C170.2 186 170.6 186.4 171 186.4H193.7V177.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8 176.399H129.3C128.5 176.399 127.9 176.999 127.9 177.799V185.899C127.9 186.699 128.5 187.299 129.3 187.299H167.8C168.6 187.299 169.2 186.699 169.2 185.899V177.799C169.2 176.999 168.6 176.399 167.8 176.399Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.8 176.399H129.3C128.5 176.399 127.9 176.999 127.9 177.799V185.899C127.9 186.699 128.5 187.299 129.3 187.299H167.8C168.6 187.299 169.2 186.699 169.2 185.899V177.799C169.2 176.999 168.6 176.399 167.8 176.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M164.201 178.499H136.001C135.501 178.499 135.101 178.899 135.101 179.399V184.299C135.101 184.799 135.501 185.199 136.001 185.199H164.201C164.701 185.199 165.101 184.799 165.101 184.299V179.399C165.101 178.899 164.701 178.499 164.201 178.499Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 171.2C157.7 171.2 157.1 171.6 157.1 172V175.6C157.1 176.1 157.7 176.4 158.5 176.4H203.9C204.2 176.4 204.4 176.3 204.4 176.1V171.4C204.4 171.3 204.2 171.1 203.9 171.1H158.5V171.2Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M204.4 171.699H185.2C184.9 171.699 184.6 171.999 184.6 172.299V175.299C184.6 175.599 184.9 175.899 185.2 175.899H204.4V171.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6 171.199H136.1C135.5 171.199 135 171.699 135 172.299V175.399C135 175.999 135.5 176.499 136.1 176.499H182.6C183.2 176.499 183.7 175.999 183.7 175.399V172.299C183.7 171.599 183.2 171.199 182.6 171.199Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.6 171.199H136.1C135.5 171.199 135 171.699 135 172.299V175.399C135 175.999 135.5 176.499 136.1 176.499H182.6C183.2 176.499 183.7 175.999 183.7 175.399V172.299C183.7 171.599 183.2 171.199 182.6 171.199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142 171.199H140.5C140.4 171.199 140.3 171.299 140.3 171.399V176.199C140.3 176.299 140.4 176.399 140.5 176.399H142C142.1 176.399 142.2 176.299 142.2 176.199V171.399C142.2 171.199 142.1 171.199 142 171.199Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M179.7 171.199H178.3C178.2 171.199 178.1 171.299 178.1 171.399V176.199C178.1 176.299 178.2 176.399 178.3 176.399H179.7C179.8 176.399 179.9 176.299 179.9 176.199V171.399C179.9 171.199 179.8 171.199 179.7 171.199Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3 163.6C149.5 163.6 148.9 164 148.9 164.4V170.3C148.9 170.8 149.5 171.1 150.3 171.1H199.4C199.7 171.1 199.9 171 199.9 170.8V163.8C199.9 163.7 199.7 163.5 199.4 163.5H150.3V163.6Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M199.9 164.1H177C176.7 164.1 176.4 164.4 176.4 164.7V170C176.4 170.3 176.7 170.6 177 170.6H199.9V164.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.401 163.6H135.201C134.601 163.6 134.101 164.1 134.101 164.7V170.1C134.101 170.7 134.601 171.2 135.201 171.2H174.401C175.001 171.2 175.501 170.7 175.501 170.1V164.7C175.501 164.1 175.001 163.6 174.401 163.6Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.401 163.6H135.201C134.601 163.6 134.101 164.1 134.101 164.7V170.1C134.101 170.7 134.601 171.2 135.201 171.2H174.401C175.001 171.2 175.501 170.7 175.501 170.1V164.7C175.501 164.1 175.001 163.6 174.401 163.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9 194.4H218.6C218.1 194.4 217.8 194.8 217.8 195.2C217.8 195.7 218.2 196 218.6 196H259.9C260.4 196 260.7 195.6 260.7 195.2C260.8 194.8 260.4 194.4 259.9 194.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.699 192.5H367.799L370.199 196H338.199L340.699 192.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 131.9C382.5 133.9 380.9 135.5 378.9 135.5C376.9 135.5 375.3 133.9 375.3 131.9C375.3 129.9 376.9 128.3 378.9 128.3C380.9 128.2 382.5 129.9 382.5 131.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.1 194.9C355 194.9 354.8 194.9 354.7 194.8C354.1 194.6 353.8 193.9 354.1 193.3L380.2 131.5C380.4 130.9 381.1 130.6 381.7 130.9C382.3 131.1 382.6 131.8 382.3 132.4L356.2 194.2C356 194.6 355.6 194.9 355.1 194.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.2 133C381 133 380.7 132.9 380.5 132.8L333 97.2001C332.5 96.8001 332.4 96.1001 332.8 95.6001C333.2 95.1001 333.9 95.0001 334.4 95.4001L381.9 131C382.4 131.4 382.5 132.1 382.1 132.6C381.9 132.9 381.6 133 381.2 133Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.899 131.9C384.899 133.9 383.299 135.5 381.299 135.5C379.299 135.5 377.699 133.9 377.699 131.9C377.699 129.9 379.299 128.3 381.299 128.3C383.299 128.3 384.899 129.9 384.899 131.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.799 99.9002C335.787 99.9002 337.399 98.2884 337.399 96.3002C337.399 94.312 335.787 92.7002 333.799 92.7002C331.811 92.7002 330.199 94.312 330.199 96.3002C330.199 98.2884 331.811 99.9002 333.799 99.9002Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7 112.9C325.5 116.1 320.4 116.1 317.2 112.9C314 109.7 314 104.6 317.2 101.4C320.4 98.2 325.5 98.2 328.7 101.4C331.9 104.6 331.9 109.8 328.7 112.9Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M328.7 112.9C325.5 116.1 320.4 116.1 317.2 112.9C314 109.7 314 104.6 317.2 101.4C320.4 98.2 325.5 98.2 328.7 101.4C331.9 104.6 331.9 109.8 328.7 112.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8 96.3002C327 89.5002 315.9 89.5002 309.1 96.3002L333.8 121C340.6 114.2 340.6 103.1 333.8 96.3002Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.1 96.2998L205.2 196.1H311.7L333.8 121L309.1 96.2998Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M309.1 96.2998L205.2 196.1H311.7L333.8 121L309.1 96.2998Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 372.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmsProject);
export default __webpack_public_path__ + "static/media/Lms-Project.9bfd9d0b7364eabfcd81d62108821409.svg";
export { ForwardRef as ReactComponent };